export default {
  'disablements': 'Discapacidades',
  'search.customers': 'Buscar clientes',
  'search.results': 'Resultados de la Búsqueda',
  'towingNeeded': 'Se Necesita Remolque',
  'towingNotNeeded': 'Remolque No es necesario',
};